import React from 'react';
import Radium from 'radium';
import StyleDecorator from '../StyleDecorator';
import TextInput from './TextInput';

class UsernameInput extends React.Component {
	static propTypes = {
		onInputChange: React.PropTypes.func,
		onInputBlur: React.PropTypes.func,
	};

	state = {
		valid: true,
	};

	isValid(username) {
		return !!username;
	}

	handleBlur = (e) => {
		if (e.target.value.length) {
			this.setState({ valid: this.isValid(e.target.value) });
		} else {
			this.setState({ valid: true });
		}
	}

	handleChange = (e) => {
		if (e.target.value.length && !this.state.valid) {
			this.setState({ valid: this.isValid(e.target.value) });
		}
	}

	render() {
		return (
			<TextInput
				onInputBlur={this.handleBlur}
				onInputChange={this.handleChange}
				type={'email'}
				valid={this.state.valid}
				{...this.props}
			/>
		);
	}
}

export default StyleDecorator(Radium(UsernameInput));



// WEBPACK FOOTER //
// ./src/components/inputs/UsernameInput.js